export const ActionTypes = {
  LOADING: "GET_INSTRUCTIONS_LOADING",
  ERROR: "GET_INSTRUCTIONS_ERROR",
  SUCCESS: "GET_INSTRUCTIONS_SUCCESS"
};
